import React from 'react';

export default function ConversionFlowSteps({ steps, setStep }) {

    const isStepCompleted = (step) => {
        const activeStep = steps.find((step) => step.active);
        return step.position < activeStep.position;
    }

    const activateStep = (step) => {
        if (isStepCompleted(step)) {
            setStep(step);
        }
    }

    return (
        <div className="flow__steps mb-2 mb-lg-10">
            <div className="row gutters-2 gutters-lg-8">
                {steps && steps.filter((step) => !step.hidden).map((step) => (
                    <div key={step.id} className="col-auto">
                        <div
                            onClick={() => activateStep(step)}
                            className={`flow__step d-flex align-items-center ${isStepCompleted(step) && 'is-complete'} ${step.active && 'is-active'}`}
                        >
                            <div className="flow__step-position d-flex align-items-center justify-content-center">
                                {step.position}
                            </div>
                            <span className="flow__step-name">
                                {step.name}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}